import React from "react";
import { PropTypes } from "prop-types";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const EntityDetails = ({ inputs, width }) => {
  return (
    <div>
      {inputs.map((input, index) => {
        const rawValue = input.value;
        const isNullOrEmpty = (rawValue === null || rawValue === undefined || rawValue === "");

        let valueText;
        if (typeof rawValue === "object" && rawValue !== null) {
          valueText = Object.entries(rawValue).map(([k, v]) => `${k}: ${v}`).join("\n");
        } else if (isNullOrEmpty) {
          valueText = "-";
        } else {
          valueText = rawValue;
        }

        const isMultiline = typeof valueText === 'string' && valueText.includes("\n");
        const rowCount = isMultiline ? Math.max(2, valueText.split("\n").length) : 1;

        return (
          <InputGroup className="mb-3" key={index}>
            <InputGroup.Text style={{ width: width }}>
              {input.label}
            </InputGroup.Text>
            {isMultiline ? (
              <Form.Control
                as="textarea"
                value={valueText}
                readOnly
                rows={rowCount}
                style={{
                  whiteSpace: "pre-line",
                  resize: "none",
                }}
              />
            ) : (
              <Form.Control value={valueText} readOnly />
            )}
          </InputGroup>
        );
      })}
    </div>
  );
};

export default EntityDetails;

EntityDetails.propTypes = {
  inputs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
};
